// extracted by mini-css-extract-plugin
export var bottomBorder = "course-module--bottom-border--16384";
export var courseDescription = "course-module--course-description--fe2d2";
export var instructor = "course-module--instructor--57408";
export var instructorAvatar = "course-module--instructor-avatar--103d4";
export var instructorName = "course-module--instructor-name--51f23";
export var listBorders = "course-module--list-borders--89ae1";
export var pillsList = "course-module--pills-list--a5352";
export var seeMoreBtn = "course-module--see-more-btn--b4b27";
export var signUpBox = "course-module--sign-up-box--9bd19";
export var signUpBoxAbsolute = "course-module--sign-up-box-absolute--d730d";
export var signUpBoxFixed = "course-module--sign-up-box-fixed--a47e4";
export var topBorder = "course-module--top-border--55b14";